export class AssociateOptionUI {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get option() {
        return this.parent;
    }
    get wasAtLeastOneAssociated() {
        return this.option.associatedAssociations.length > 0;
    }
    get areAllAssigned() {
        return !this.option.question.associationsToAsk.find(association => !association.isAssociationComplete && association.targetOption === this.option);
    }
    get areAllCorrectlyAssigned() {
        return (this.areAllAssigned && !this.option.associatedAssociations.find(association => association.isWronglyAssociated));
    }
    get shouldShowTemporaryFalseFeedback_1500ms() {
        if (!this.option.question.currentAssociation)
            return false;
        if (this.option.question.currentAssociation.failedOptionNumber !== this.option.optionNumber)
            return false;
        if (!this.option.question.currentAssociation.dateOfLatestFailedAttempt)
            return false;
        return (this.option.context.app.appClock.clock_250.tickingTime <=
            this.option.question.currentAssociation.dateOfLatestFailedAttempt.getTime() + 1500);
    }
}
